// src/store/nutritionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api";

export const loadReferenceProfile = createAsyncThunk(
  "nutrition/loadReferenceProfile",
  async ({ sex, age }) => {
    const ageNum = age != null ? Number(age) : null;

    const { data } = await api.get("/api/nutrition/recommendations", {
      params: {
        sex: sex || undefined,
        age: ageNum || undefined,
      },
    });

    return data || {};
  }
);

const slice = createSlice({
  name: "nutrition",
  initialState: {
    profile: {}, 
  },
  reducers: {
    resetNutrition: (state) => {
      state.profile = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadReferenceProfile.fulfilled, (state, action) => {
      state.profile = action.payload || {};
    });
  },
});

export const { resetNutrition } = slice.actions;
export default slice.reducer;

// Selector
export const selectProfile = (state) => state.nutrition.profile || {};